import styled from 'styled-components/macro';

export const WrapperStyled = styled.div`
  width: fit-content;
  position: relative;
`;
